export class iALSCause {
    public alsCauseId: number;
    public alsCauseName: string;
    public isRED: boolean;
}

export class iALSCauses {
    public list: Array<iALSCause>;

    public hasError: boolean;
    public errorMessage: string;

    constructor(errorMessage: string) {
        if (errorMessage == null) {
            this.hasError = false;
            this.errorMessage = null;

            this.list = new Array<iALSCause>();
        } else {
            this.hasError = true;
            this.errorMessage = errorMessage;

            this.list = null;
        }
        
    };
}


// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/interfaces/lookups/ALS/iALSCause.ts